import { Modal } from "antd";
import type { ReactNode } from "react";

interface FormModalProps {
	open: boolean;
	/** Whether the modal edits an existing record (drives default title/okText). */
	editing?: boolean;
	/** Title when creating. Used with `editTitle` when `editing` is true. */
	title: ReactNode;
	/** Title when editing (falls back to `title`). */
	editTitle?: ReactNode;
	onCancel: () => void;
	onOk: () => void;
	confirmLoading?: boolean;
	width?: number;
	children: ReactNode;
}

/**
 * Thin wrapper around AntD `Modal` for create/edit forms. Standardizes ok/cancel labels,
 * `destroyOnHidden`, and the create-vs-edit title — the shell repeated in every *FormModal.
 * Form logic (useForm, validate, mutate) stays in the calling component.
 */
export function FormModal({
	open,
	editing,
	title,
	editTitle,
	onCancel,
	onOk,
	confirmLoading,
	width = 720,
	children,
}: FormModalProps) {
	return (
		<Modal
			title={editing ? (editTitle ?? title) : title}
			open={open}
			onCancel={onCancel}
			onOk={onOk}
			confirmLoading={confirmLoading}
			okText={editing ? "Saqlash" : "Yaratish"}
			cancelText="Bekor qilish"
			destroyOnHidden
			width={width}
		>
			{children}
		</Modal>
	);
}
